.filter-bar-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 32px;
}
